import { FlatList, Pressable, ScrollView, Text, View } from "react-native"
import useKanbanStyle from './Kanban.styles';
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";
import { Fragment, useCallback, useMemo, useState } from "react";
import { Element, FilterOption, KanbanProps } from "./Kanban.types";

export default function Kanban<T>({colonnes, orderField, categoryField, borderWidth, noContentText, content, subContent, onElementPressed}: KanbanProps<T>){
    const {styles} = useKanbanStyle();

    const [selectedFilter, setSelectedFilter] = useState('tous');

    const filterOptions = useMemo<FilterOption[]>(() => ([
        {value: 'tous', label: 'TOUS'},
        ...colonnes.map((colonne) => ({value: colonne.title, label: colonne.title.toUpperCase()})),
    ]),[colonnes])

    const sortedElementsColonnes = useMemo(() => {
        return colonnes.filter((colonne) => selectedFilter === 'tous' || colonne.title === selectedFilter).map((colonne) => {
            colonne.elements.sort((a, b) => {
                if(categoryField){
                    if(a[categoryField] > b[categoryField]){
                        return 1
                    }
                    if(a[categoryField] < b[categoryField]){
                        return -1
                    }
                }
                if(orderField){
                    if(a[orderField] > b[orderField]){
                        return 1
                    }
                    if(a[orderField] < b[orderField]){
                        return -1
                    }
                }
                return 0
            })
            if(categoryField) {
                colonne.elements = colonne.elements.map((element, index) => {
                    if(index === 0 || element[categoryField] !== colonne.elements[index-1][categoryField]){
                        element.newCategory = true;
                    }
                    return element;
                })
            }
            return colonne;
        })
    }, [categoryField, colonnes, orderField, selectedFilter])

    const handleElementPressed = useCallback((element: Element<T>) => () => {
        onElementPressed?.(element)
    }, [onElementPressed])

    // Fonction pour changer le filtre
    const handleFilterChange = (filter: string) => {
        setSelectedFilter(filter)
    }

    return (
        <View style={styles.mainContainer}>
            {/* Filtre par type de demande */}
            <View style={styles.filterContainer}>
                <FlatList
                    data={filterOptions}
                    horizontal
                    renderItem={({item}) => (
                        <Pressable
                            key={item.value}
                            style={[
                                styles.filterChip,
                                selectedFilter === item.value && styles.filterChipSelected
                            ]}
                            onPress={() => handleFilterChange(item.value)}
                            testID={`BT_FILTER_${item.value}`}
                        >
                            <Text style={[
                                styles.filterChipText,
                                selectedFilter === item.value && styles.filterChipTextSelected
                            ]}>
                                {item.label}
                            </Text>
                        </Pressable>
                    )}
                    testID='SC_FILTERS'
                />
            </View>
            <View style={styles.subContainer}>
                <ScrollView
                    style={styles.subContainer}
                    showsVerticalScrollIndicator={false}
                    testID='SC_MAIN_CONTENT'
                >
                    <View style={styles.innerContainer}>
                        {sortedElementsColonnes.map(({title, elements, logo, logoColor, subHeader, nbElementsLigne}) => (
                            <View key={title} style={styles.columnContainer}>
                                <View style={styles.columnHeader}>
                                    <View style={styles.mainHeaderContainer}>
                                        {logo && (
                                            <MaterialCommunityIcons
                                                name={logo}
                                                size={24}
                                                color={logoColor}
                                            />
                                        )}
                                        <Text style={styles.columnTitle}>
                                            {title.toUpperCase()}
                                        </Text>
                                    </View>
                                    {subHeader}
                                </View>
                                <View style={styles.columnContent}>
                                    {elements.length === 0 ? (
                                        <Text style={styles.emptyText}>{noContentText}</Text>
                                    ) : elements.map((element) => (
                                        <Fragment key={element.identifiant}>
                                            {categoryField && element.newCategory && (
                                                <Text style={styles.columnSubtitle}>{(element[categoryField] as string)}</Text>
                                            )}
                                            <Pressable
                                                onPress={handleElementPressed(element)}
                                                style={[styles.elementItem, { borderLeftWidth: borderWidth || 0, borderColor: element.borderColor, width: `${100/(nbElementsLigne||1) - 1}%` }]}
                                            >
                                                {content(element)}
                                                {subContent?.(element)}
                                            </Pressable>
                                        </Fragment>
                                    ))}
                                </View>
                            </View>
                        ))}
                    </View>
                </ScrollView>
            </View>
        </View>
    )
}
